import React from 'react';

function VendorInfo({ vendor, handleChange }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      <label>
        Name:
        <input type="text" name="name" value={vendor.name || ''} onChange={handleChange} />
      </label>
      <label>
        Address:
        <input type="text" name="address" value={vendor.address || ''} onChange={handleChange} />
      </label>
      <label>
        City:
        <input type="text" name="city" value={vendor.city || ''} onChange={handleChange} />
      </label>
      <label>
        State:
        <select name="state" value={vendor.state || ''} onChange={handleChange}>
          <option value="">Select state</option>
          <option value="AL">Alabama</option>
          <option value="AK">Alaska</option>
          <option value="AZ">Arizona</option>
          <option value="AR">Arkansas</option>
          <option value="CA">California</option>
          <option value="CO">Colorado</option>
          <option value="CT">Connecticut</option>
          <option value="DE">Delaware</option>
          <option value="FL">Florida</option>
          <option value="GA">Georgia</option>
          <option value="HI">Hawaii</option>
          <option value="ID">Idaho</option>
          <option value="IL">Illinois</option>
          <option value="IN">Indiana</option>
          <option value="IA">Iowa</option>
          <option value="KS">Kansas</option>
          <option value="KY">Kentucky</option>
          <option value="LA">Louisiana</option>
          <option value="ME">Maine</option>
          <option value="MD">Maryland</option>
          <option value="MA">Massachusetts</option>
          <option value="MI">Michigan</option>
          <option value="MN">Minnesota</option>
          <option value="MS">Mississippi</option>
          <option value="MO">Missouri</option>
          <option value="MT">Montana</option>
          <option value="NE">Nebraska</option>
          <option value="NV">Nevada</option>
          <option value="NH">New Hampshire</option>
          <option value="NJ">New Jersey</option>
          <option value="NM">New Mexico</option>
          <option value="NY">New York</option>
          <option value="NC">North Carolina</option>
          <option value="ND">North Dakota</option>
          <option value="OH">Ohio</option>
          <option value="OK">Oklahoma</option>
          <option value="OR">Oregon</option>
          <option value="PA">Pennsylvania</option>
          <option value="RI">Rhode Island</option>
          <option value="SC">South Carolina</option>
          <option value="SD">South Dakota</option>
          <option value="TN">Tennessee</option>
          <option value="TX">Texas</option>
          <option value="UT">Utah</option>
          <option value="VT">Vermont</option>
          <option value="VA">Virginia</option>
          <option value="WA">Washington</option>
          <option value="WV">West Virginia</option>
          <option value="WI">Wisconsin</option>
          <option value="WY">Wyoming</option>
        </select>
      </label>
      <label>
        Zip:
        <input type="text" name="zip" value={vendor.zip || ''} onChange={handleChange} />
      </label>
      <label>
        Status:
        <select name="status" value={vendor.status || ''} onChange={handleChange}>
          <option value="">Select status</option>
          <option value="Active">Active</option>
          <option value="Inactive">Inactive</option>
          <option value="Onboarding">Onboarding</option>
        </select>
      </label>
      <label>
        Start Date:
        <input type="date" name="startDate" value={vendor.startDate || ''} onChange={handleChange} />
      </label>
      <label>
        Invoiced:
        <select name="invoiced" value={vendor.invoiced ? 'true' : 'false'} onChange={handleChange}>
          <option value="false">No</option>
          <option value="true">Yes</option>
        </select>
      </label>
      <label>
        Access Code:
        <input type="text" name="accessCode" value={vendor.accessCode || ''} onChange={handleChange} />
      </label>
    </div>
  );
}

export default VendorInfo;
